
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ProfileForm from "./ProfileForm";
import DemographicsForm from "./DemographicsForm";
import IdentityVerificationForm from "./IdentityVerificationForm";
import { UserHistory } from "./UserHistory";
import HowToVerify from "./HowToVerify";
import { NotificationPreferences } from "./NotificationPreferences";
import SecuritySettingsForm from "./SecuritySettingsForm";
import MultiCountryPointsDashboard from "./MultiCountryPointsDashboard";
import { GdprDataExport } from "./GdprDataExport";
import { Shield, Coins } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import DeleteAccountSection from "./DeleteAccountSection";

const ProfileTabs = ({
  activeTab,
  setActiveTab,
}: {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}) => {
  const isMobile = useIsMobile();

  return (
    <Tabs
      value={activeTab}
      onValueChange={setActiveTab}
      className="w-full"
      defaultValue="profile"
    >
      <TabsList
        className={`grid w-full ${
          isMobile ? "grid-cols-4" : "grid-cols-8"
        } mb-8`}
      >
        <TabsTrigger value="howto" className="text-xs sm:text-sm">
          How To
        </TabsTrigger>
        <TabsTrigger value="profile" className="text-xs sm:text-sm">
          Profile
        </TabsTrigger>
        <TabsTrigger value="demographics" className="text-xs sm:text-sm">
          Demographics
        </TabsTrigger>
        <TabsTrigger value="points" className="text-xs sm:text-sm">
          Points
        </TabsTrigger>
        {isMobile ? (
          <>
            <TabsTrigger value="verification" className="text-xs sm:text-sm">
              Verify
            </TabsTrigger>
            <TabsTrigger value="notifications" className="text-xs sm:text-sm">
              Notify
            </TabsTrigger>
            <TabsTrigger value="security" className="text-xs sm:text-sm">
              Security
            </TabsTrigger>
            <TabsTrigger value="privacy" className="text-xs sm:text-sm">
              Privacy
            </TabsTrigger>
          </>
        ) : (
          <>
            <TabsTrigger value="verification" className="text-xs sm:text-sm">
              Verification
            </TabsTrigger>
            <TabsTrigger value="notifications" className="text-xs sm:text-sm">
              Notifications
            </TabsTrigger>
            <TabsTrigger value="security" className="text-xs sm:text-sm">
              Security
            </TabsTrigger>
            <TabsTrigger value="privacy" className="text-xs sm:text-sm">
              Privacy & Data
            </TabsTrigger>
          </>
        )}
      </TabsList>
      <TabsContent value="profile" className="mt-0">
        <ProfileForm />
      </TabsContent>
      <TabsContent value="security" className="mt-0">
        <SecuritySettingsForm />
      </TabsContent>
      <TabsContent value="points" className="mt-0">
        <MultiCountryPointsDashboard />
      </TabsContent>
      <TabsContent value="demographics" className="mt-0">
        <DemographicsForm />
      </TabsContent>
      <TabsContent value="verification" className="mt-0">
        <IdentityVerificationForm />
      </TabsContent>
      <TabsContent value="notifications" className="mt-0">
        <NotificationPreferences />
      </TabsContent>
      <TabsContent value="howto" className="mt-0">
        <HowToVerify />
      </TabsContent>
      <TabsContent value="privacy" className="mt-0 space-y-6">
        <GdprDataExport />
        <DeleteAccountSection />
      </TabsContent>
    </Tabs>
  );
};

export default ProfileTabs;

